
import icArr from '../../assets/questions/ic-arr.svg';
import icArrow from '../../assets/questions/ic-arrow.svg';
import questionImage from '../../assets/questions/question.png';
import Animate from '../Animate';
const Questions = ({ t, questions, handleAnswerToggle, answerOpen })=> (
    <div id="questions" className="landing-conatiner-questions">
        <div className="landing-layout">
            <div className="landing-page-questions">
                <Animate>
                    <h2 className="landing-section-title">{ t("landing.questions.title") }</h2>
                </Animate>
                <img
                    className="landing-section-image"
                    src={questionImage}
                    alt=""
                />
                <div className="landing-bars">
                    {
                        questions.map (({title, text}, index) => (
                            <div
                                key={ index }
                                className="landing-bars-container"
                                onClick={e => handleAnswerToggle(e, index + 1)}
                                onKeyPress={e => handleAnswerToggle(e, index + 1)}
                                role="button"
                            >
                                <div className="landing-bars-header">
                                    <div className="landing-bars-title"><p >{ title }</p></div>
                                    <div>
                                        {
                                        answerOpen === (index + 1)
                                        ? <img src={icArr} alt=""/>
                                        : <img src={icArrow} alt=""/>
                                        }
                                    </div>
                                </div>
                                <div className="landing-bars-content">
                                    {
                                        answerOpen === (index + 1) && (
                                            <p>{ text }</p>
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    </div>
)

export default Questions;
